import type { C1_FurnitureDefinition, C1_FurnitureRendererProps } from "../../types/C1_FurnitureTypes";
import { RoomType } from "../../types/C1_ModelTypes";
import { C1_FurnitureSvg } from "../C1_FurnitureSvg";
import { C1_FurnitureIcon } from "../C1_FurnitureIcon";

const DEFAULT_WIDTH = 1.8;
const DEFAULT_HEIGHT = 0.8;

const Bathtub: C1_FurnitureDefinition = {
  id: "bathtub",
  icon: <C1_FurnitureIcon kind="bathtub" />,
  description: { en: "Bathtub", de: "Badewanne" },
  category: RoomType.Bathroom,
  defaultWidth: DEFAULT_WIDTH,
  defaultHeight: DEFAULT_HEIGHT,
  autoRotate: true,
  autoReflect: true,
  properties: [],
  Renderer: ({
    width,
    height,
    rotation,
    PX,
    strokeWidth,
    strokeColor,
    fillColor,
    showDetails,
  }: C1_FurnitureRendererProps) => {
    const finalRotation = rotation ?? 0;
    const finalStrokeWidth = strokeWidth ?? 2;
    const finalStrokeColor = strokeColor ?? "#000000";
    const finalFillColor = fillColor ?? "#ffffff";
    const inset = 0.02 * PX;
    const outerRadius = Math.min(0.12 * PX, width / 2, height / 2);
    const innerInsetX = Math.min(0.14 * PX, width * 0.25);
    const innerInsetY = Math.min(0.12 * PX, height * 0.25);

    return (
      <C1_FurnitureSvg
        PX={PX}
        width={width}
        height={height}
        rotation={finalRotation}
        viewBoxWidth={width}
        viewBoxHeight={height}
        originXPercentage={0}
        originYPercentage={0}
      >
        <g transform={`translate(${width} 0) scale(-1 1)`}>
          <rect
            x={inset}
            y={inset}
            width={Math.max(0, width - inset * 2)}
            height={Math.max(0, height - inset * 2)}
            rx={outerRadius}
            fill={finalFillColor}
            stroke={finalStrokeColor}
            strokeWidth={finalStrokeWidth * 2}
          />
          {showDetails && (
            <>
              <rect
                x={innerInsetX}
                y={innerInsetY}
                width={Math.max(0, width - innerInsetX * 2)}
                height={Math.max(0, height - innerInsetY * 2)}
                rx={Math.min(0.22 * PX, width / 2, height / 2)}
                fill="none"
                stroke={finalStrokeColor}
                strokeWidth={finalStrokeWidth}
              />
              <circle
                cx={Math.min(0.3 * PX, width * 0.25)}
                cy={height / 2}
                r={Math.min(0.04 * PX, width * 0.06, height * 0.06)}
                fill="none"
                stroke={finalStrokeColor}
                strokeWidth={finalStrokeWidth}
              />
            </>
          )}
        </g>
      </C1_FurnitureSvg>
    );
  },
};

export default Bathtub;
